import { isACQ177ProductisedFlow } from './isACQ177ProductisedFlow';
import { isPurchaseProductisedFlow } from './isPurchaseProductisedFlow';
import { isMarketingProductisedFlow } from './isMarketingProductisedFlow';
import { getIsNewUserExperiment } from '../../experiments/ExperimentUtils';
import { getIsJapan } from '../getIsJapan';
import { getIsMobile } from '../deviceUtils';
import { SignupEmbedder } from 'signup-embedder';
import { getIntentKey } from '../../routing/getIntentKey';
import { getIsEnglishLanguage } from '../../i18n/LanguageUtils';
import { getIsGoogleCredentialAuthentication } from '../../google-authentication/google-prompt/getIsGoogleCredentialAuthentication';
import { getIsExistingUserSession, getIsOAuthExistingUser } from '../../store/app/selectors';
import { isProductisedSignupFlow } from './isProductisedSignupFlow';
export const isEligibleForACQ177ProductisedFlow = state => {
  if (!isACQ177ProductisedFlow()) {
    return false;
  }

  // TODO: Remove this check when ACQ177 code is cleaned up
  // This is left to avoid unit test errors, but at runtime su-0004 takes precedence over acq-0177
  if (isProductisedSignupFlow(state)) {
    return false;
  }

  // OAuth existing users have IsExistingUserSession=false until they reach the
  // ExistingUser step, so getIsNewUserExperiment() incorrectly returns true for
  // them. Guard against this to avoid routing them through the new-user GTKM path.
  const isNewOrPurchaseExistingUser = getIsNewUserExperiment(state) && !getIsOAuthExistingUser(state) || isPurchaseProductisedFlow() && getIsExistingUserSession(state) || isMarketingProductisedFlow() && getIsExistingUserSession(state);
  return isNewOrPurchaseExistingUser && getIsEnglishLanguage() && !getIsJapan(state) && !getIsMobile() && !SignupEmbedder.isActive() && (isPurchaseProductisedFlow() || isMarketingProductisedFlow() || !getIntentKey()) && !getIsGoogleCredentialAuthentication(state);
};